<template>
    <div id="aqt_footer">
      <div class="footer_content">
        <div class="footer_up">
          <div class="footer_up_left">
            <p class="left_item">地址:内蒙古自治区呼和浩特市赛罕区金桥数智园</p>
            <p class="left_item">电话:18516170412（微信同步）</p>
            <div class="national3">
              <a target="_blank" href="http://www.beian.miit.gov.cn" class="national2_link">

              <img src="../assets/img/app.png" class="national_img"/>
              <p class="records">蒙ICP备16004441号-2</p>
              </a>
            </div>
            <div class="national4">
              <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15010502001000" class="national2_link">
                <img src="../assets/img/app1.png" class="national_img"/>
                <p class="records">蒙公网安备 15010502001000号</p>
              </a>
            </div>
          </div>
          <div class="footer_up_right">
            <router-link to="/Personal" class="right_item">
              <img src="../assets/img/pc_index11.png" class="footer_img"/>
              <p class="footer_nav">关于我们</p>
            </router-link>
            <div class="right_item">
              <img src="../assets/img/pc_index12.png"  class="footer_img"/>
              <p class="footer_nav">商业合作</p>
            </div>
            <div class="right_item">
              <a target="_blank" href="http://www.nudel.cn/">
                <img src="../assets/img/pc_index13.png"  class="footer_img"/>
                <p class="footer_nav">游牧文化</p>
              </a>

            </div>
          </div>
        </div>

        <div class="footer_down">
          <div class="down_left">
            <p>（建议您使用IE9及以上版本浏览器访问本网站）</p>
            <img  src="../assets/img/footer1.png" class="footer_img1"/>
          </div>
          <div class="down_right">
            <img  src="../assets/img/index13.png"  class="footer_img2"/>
            <p>2019内蒙古阿启泰科技有限公司版权所有</p>
          </div>
        </div>
      </div>
      <div class="footer_line"></div>
    </div>
</template>

<script>
    export default {}
</script>

<style   scoped lang="less">
  #aqt_footer{
    width:100%;
    background-image: linear-gradient(to right,#272D74 0,#061248 100%);
    position:relative;
    .footer_line{
      height:1px;
      width:100%;
      background-color:#D3DFFF;
      position:absolute;
      top:85%;

    }
    .footer_content{
      width:70%;
      height:100%;
      margin:0 auto;
      display:flex;
      flex-direction:column;
      color: #D3DFFF;
      .records{
        font-size:13px;
      }
      .national3{
        width:100%;
        height:auto;
        display:flex;
        flex-direction:row;
        font-size:12px;
        margin-top:3%;
        .national_img{
          width:15px;

        }
      };
      .national4{
        width: 70%;
        height: auto;
        margin-top: 3%;
        margin-bottom: 3%;

      }
      .footer_up{
        width:100%;
        height:80%;
        display:flex;
        flex-direction:row;
        .footer_up_left{
          width:60%;
          height:100%;
          .left_item{
            font-size:13px;
            margin-top:3%;
          }
        }

        .footer_up_right{
          width:40%;
          height:100%;
          display:flex;
          flex-direction:row;
          /*margin-left:13%;*/
          .right_item{
            width:20%;
            display:flex;
            flex-direction:column;
            font-size: 10px;
            margin-left: 10%;
            margin-top: 15%;
            .footer_img{
              height:30px;
              width:30px;
              margin-bottom: 20%;
              margin-left:13%;
            }
            .footer_nav{
              color:#D3DFFF;
              font-size:13px;
            }

          }
        }
      }
      .footer_down{
        width:100%;
        height:20%;
        display:flex;
        flex-direction:row;
        font-size:10px;
        margin-top: 9%;
        .down_left{
          width:60%;
          height:100%;
          display:flex;
          flex-direction:row;
          .footer_img1{
            height:60%;
            margin-left:4%;
            margin-top: 0.5%;
          }
        }
        .down_right{
          width:40%;
          height:100%;
          display:flex;
          flex-direction:row;
          .footer_img2{
            width:10px;
            height:10px;
            margin-right:2%;
            margin-top:1%;
            margin-left:21%;
          }
        }
      }
    }
  }
</style>
